<template>
  <section :id="anchorId" class="summary-panel">
    <header class="summary-panel-header">
      <h5 class="summary-panel-title">{{ title }}</h5>
      <span
        v-for="badge in badges"
        :key="badge.label"
        class="summary-panel-badge"
        :class="{ 'summary-panel-badge-warn': badge.warn }"
      >{{ badge.label }}</span>
    </header>
    <slot />
  </section>
</template>

<script>
export default {
  name: 'SummaryPanel',
  props: {
    title: {
      type: String,
      required: true,
    },
    badges: {
      type: Array,
      default: () => [],
    },
    anchorId: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped>
.summary-panel {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 12px;
  min-width: 0;
  /* nav HP sticky 70px + pill */
  scroll-margin-top: 124px;
}

.summary-panel-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
  margin-bottom: 8px;
}

.summary-panel-title {
  font-size: 16.8px;
  font-weight: 600;
  color: #000;
  margin: 0;
}

.summary-panel-badge {
  font-size: 12.25px;
  font-weight: 600;
  line-height: 1.4;
  padding: 1px 8px;
  border-radius: 10px;
  background: #fff3cd;
  color: #856404;
}

.summary-panel-badge-warn {
  background: #f8d7da;
  color: #721c24;
}
</style>
